<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <div [innerHTML]="data.message"></div>
  <mat-form-field class="col-12">
    <mat-label>{{'MarketMonitor.monitor.marketContribute.lblReason' | translate}}</mat-label>
    <input type="text" matInput placeholder="{{'MarketMonitor.monitor.marketContribute.lblReason' | translate}}"
      [(ngModel)]="reason" [ngModelOptions]="{standalone: true}"
      required />
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="OnClickYes()">{{ 'dialog.btnYes' | translate }}</button>&nbsp;
  <button mat-raised-button color="secondary" (click)="OnClickNo()">{{ 'dialog.btnNo' | translate }}</button>
</div>